import gql from 'graphql-tag'

export const LOGOUT_MUTATION = gql`
  mutation LogOutMutation ($refreshToken: String!){
    logoutUser(data: {
      refreshToken: $refreshToken
    })
  }
`
